import React from 'react';
import { Box, Typography } from '@mui/material';
import { Biotech as BiotechIcon } from '@mui/icons-material';
import ReferenceMaterialsManagement from '../../components/admin/ReferenceMaterialsManagement';

/**
 * Phase 1 — Admin OREAS / MRC catalog page.
 * Hosts the Reference-Materials management surface gated to ADMIN +
 * QUALITY_MANAGER (gating happens in App.tsx via RoleGuard).
 */
const ReferenceMaterialsCatalogPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
        >
          <BiotechIcon sx={{ fontSize: 32 }} />
          Catalogue MRC / OREAS
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Référentiel central des matériaux de référence certifiés (Phase 1 — QA/QC)
        </Typography>
      </Box>

      <ReferenceMaterialsManagement />
    </Box>
  );
};

export default ReferenceMaterialsCatalogPage;
